// core version + navigation, pagination modules:
import Swiper from 'swiper/bundle';

// import Swiper and modules styles
import 'swiper/css/bundle';


const swiper = new Swiper(".swiper-container", {
    on: {
        init: function() {
            const parentEl = this.wrapperEl.parentNode;
            const scrollBarLock = parentEl.querySelector(".swiper-scrollbar-lock");

            console.log(parentEl);

            if (scrollBarLock) {
                parentEl.classList.add("scrollbar-hidden");
            }

        }
    },
    slidesPerView: 7,
    spaceBetween: 25,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    loop: false,
    scrollbar: {
        el: ".swiper-scrollbar",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: "fraction", // Use fraction type to match the design in the image
        formatFractionCurrent: function (number) {
            return ("0" + number).slice(-2);
        },
        formatFractionTotal: function (number) {
            return ("0" + number).slice(-2);
        },
        renderFraction: function (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>' + '<span class="divider"> / </span>' + '<span class="' + totalClass + '"></span>';
        },
    },
    breakpoints: {
        320: {
            slidesPerView: 2,
            spaceBetween: 8,
        },
        768: {
            slidesPerView: 3.5,
        },
        1024: {
            slidesPerView: 4.5,
        },
        1200: {
            slidesPerView: 5,
        },
        1440: {
            slidesPerView: 6,
        },
        1600: {
            slidesPerView: 7,
        },
    },
});

